import { render, staticRenderFns } from "./SensorDataMailer.vue?vue&type=template&id=4becceec&scoped=true"
import script from "./SensorDataMailer.vue?vue&type=script&lang=js"
export * from "./SensorDataMailer.vue?vue&type=script&lang=js"
import style0 from "./SensorDataMailer.vue?vue&type=style&index=0&id=4becceec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4becceec",
  null
  
)

export default component.exports